import applicanListActions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  actions: [],
  applicants: null,
  formInfo: {},
  filters: [],
  loading: false,
  total: 0,
};

function formatFilters(filters) {
  return filters.map(item => {
    if (item.key === 'status') {
      item.properties.options = item.properties.options.filter(option => option.id);
    }

    return item;
  });
}

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, actions, filters, savedSearches } = payload;
  const applicants = data;

  return {
    ...state,
    applicants,
    actions,
    total,
    filteredTotal,
    filters: formatFilters(filters),
    loading: false,
    savedSearches,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [applicanListActions.LOAD]: onLoad,
  [applicanListActions.LOAD_SUCCESS]: onLoadSuccess,
  [applicanListActions.CLEAR_STORE]: onClearStore,
});
